import {Inject, Injectable} from '@angular/core';
import {Observable, ReplaySubject, Subject} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {first} from 'rxjs/operators';
import {SettlementTemplate} from '../interface/settlement-template';
import {CountedAndPaginated} from "../interface/response/counted-and-paginated";
import {Contract} from "../interface/contract";
import {NewsletterService} from "./newsletter.service";
import {Newsletter} from "../interface/newsletter";
import {FilterService} from "./filter.service";
import {DOCUMENT} from "@angular/common";
import {Uuid} from "../interface/response/uuid";
import {Invoice} from "../interface/invoice";
import {ListResponse} from "../interface/response/list-response";

@Injectable({
  providedIn: 'root'
})
export class SettlementTemplateService {
  public readonly settlementTemplateListSubject: ReplaySubject<CountedAndPaginated<SettlementTemplate>> = new ReplaySubject<CountedAndPaginated<SettlementTemplate>>(1);

  constructor(
    private httpClient: HttpClient,
    private filterService: FilterService,
    @Inject(DOCUMENT) private document: Document,
  ) { }

  sendForm(formData: any, uuid?: string): Observable<Uuid> {
    if (!uuid) {
      return this.httpClient.post(`/rest/crm/settlement-template`, formData)
        .pipe(first()) as Observable<Uuid>;
    } else {
      return this.httpClient.put(`/rest/crm/settlement-template/${uuid}`, formData)
        .pipe(first()) as Observable<Uuid>;

    }
  }

  public get(uuid: string): Observable<SettlementTemplate> {
    return this.httpClient.get(`/rest/crm/settlement-template/${uuid}`)
      .pipe(first()) as Observable<SettlementTemplate>;
  }

  public delete(uuid: string): Observable<any> {
    return this.httpClient.delete(`/rest/crm/settlement-template/${uuid}`)
      .pipe(first());
  }

  getCurrent(filters: object): Observable<ListResponse<SettlementTemplate>> {
    return this.httpClient.get(`/rest/crm/settlement-template?` + this.filterService.parseFilters(filters))
      .pipe(first()) as Observable<ListResponse<SettlementTemplate>>;
  }

  sendMail(uuid: string, emailAddress: string, billingMonth: string, totalCommission: string, toPayNet: string): Observable<SettlementTemplate>{
    return this.httpClient.get(`/rest/crm/settlement-template/send-mail/${uuid}/${emailAddress}/${billingMonth}/${totalCommission}/${toPayNet}`)
      .pipe(first()) as Observable<SettlementTemplate>;
  }

  // getCurrent(billingMonth: string, companyId: number, typeOfSettlementId: number): Observable<SettlementTemplate> {
  //   return this.httpClient.get(`/rest/crm/settlement-template/${billingMonth}/${companyId}/${typeOfSettlementId}`)
  //     .pipe(first()) as Observable<SettlementTemplate>;
  // }

  public loadList(
    page: number,
    pageSize: number,
    filters: object,
    sort?: {
      sortBy?: string,
      sortOrder?: string,
    },
    subject?: Subject<CountedAndPaginated<SettlementTemplate>>): void {
    this.httpClient.get(`/rest/crm/settlement-template?page=${page + 1}&pageSize=${pageSize}&sortBy=${sort.sortBy ?? ''}&sortOrder=${sort.sortOrder ?? ''}&` + this.filterService.parseFilters(filters))
      .pipe(
        first()
      )
      .subscribe((result: CountedAndPaginated<SettlementTemplate>) => {
        if (subject) {
          subject.next(result);
        } else {
          this.settlementTemplateListSubject.next(result);
        }
      });
  }
}
